import './App.less';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import AdminLoginPage from './components/AdminLoginPage';
import RegisterPage from './components/RegisterPage';
import TermsAndConditionsPage from './components/TermsAndConditionsPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import LayoutRoute from './LayoutRoute';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import ResetPasswordPage from './components/ResetPasswordPage';
import VerifyAccountPage from './components/VerifyAccountPage';
import LogoutPage from './components/LogoutPage';
import { QueryParamProvider } from 'use-query-params';
import { CustomAppProvider } from './common/CustomAppContext';
import Error404Page from './components/Error404Page';

/**
 * @name App
 * @desc Main application component
 * @public
 */
export default function App(): JSX.Element {
    return (
        <div data-testid="app">
            <Router basename="/auth">
                <QueryParamProvider ReactRouterRoute={Route}>
                    <CustomAppProvider>
                        <Switch>
                            <LayoutRoute
                                redirectToMain={true}
                                exact
                                path="/"
                                component={LoginPage}
                            />
                            <LayoutRoute
                                redirectToMain={true}
                                exact
                                path="/admin"
                                component={AdminLoginPage}
                            />
                            <LayoutRoute
                                redirectToMain={true}
                                exact
                                path="/register"
                                component={RegisterPage}
                            />
                            <LayoutRoute
                                exact
                                path="/privacy-policy"
                                component={PrivacyPolicyPage}
                            />
                            <LayoutRoute
                                exact
                                path="/terms-and-conditions"
                                component={TermsAndConditionsPage}
                            />
                            <LayoutRoute
                                exact
                                path="/forgot-password"
                                component={ForgotPasswordPage}
                            />
                            <LayoutRoute
                                exact
                                path="/reset-password"
                                component={ResetPasswordPage}
                            />
                            <LayoutRoute
                                exact
                                path="/verify-account"
                                component={VerifyAccountPage}
                            />
                            <LayoutRoute
                                exact
                                path="/logout"
                                component={LogoutPage}
                            />
                            <LayoutRoute
                                exact
                                path="/admin/logout"
                                component={LogoutPage}
                            />
                            <LayoutRoute component={Error404Page} />
                        </Switch>
                    </CustomAppProvider>
                </QueryParamProvider>
            </Router>
        </div>
    );
}
